import React, { useEffect, useRef, useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useCreateSite } from '../hooks/site/useCreateSite';
import { AppSnackbar } from '@sierralabs/core-ui';
const CreateSiteDialog = ({ open, onCancel, onCreated }) => {
    const [formValues, setFormValues] = useState({ path: '/' });
    const { createdSite, isCreating, error, createSite } = useCreateSite();
    const onCreatedRef = useRef(onCreated);
    useEffect(() => {
        var _a;
        if (createdSite) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdSite);
        }
    }, [createdSite]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Create Site"),
        React.createElement("form", { onSubmit: event => {
                event.preventDefault();
                if (formValues.name && formValues.domain && formValues.path) {
                    createSite(formValues);
                }
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Site Name', value: formValues.name || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Site Domain', value: formValues.domain || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { domain: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Path', value: formValues.path || '/', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { path: event.target.value })) }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', type: 'submit', disabled: !formValues.name || !formValues.domain || !formValues.path, endIcon: isCreating && React.createElement(CircularProgress, { size: 20 }) }, "Submit"))),
        error && (React.createElement(AppSnackbar, { open: true, severity: 'error' }, error.message || 'An error occurred'))));
};
export default CreateSiteDialog;
//# sourceMappingURL=CreateSiteDialog.js.map